module.exports = __webpack_public_path__ + "static/media/LCC_EN.dd631239.png";


//////////////////
// WEBPACK FOOTER
// ./src/tco/assets/LCC_EN.png
// module id = 1506
// module chunks = 0